export function getFullname(lastName: string, maidenName: string, firstName: string): string {
  return `${lastName}${maidenName ? ` ${maidenName}` : ''} ${firstName}`
}